import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import BaseFoundation from '../base/foundation';
export default class BannerFoundation extends BaseFoundation {
  constructor(adapter) {
    super(_Object$assign(_Object$assign({}, BannerFoundation.defaultAdapter), adapter));
  }

  removeBanner(e) {
    this._adapter.notifyClose(e);

    this._adapter.setVisible();
  }

}